import { c as _c } from "react/compiler-runtime";
/* eslint-disable react/no-unstable-nested-components */
import type { CSSProperties, ReactNode, FC } from 'react';
import { cx } from 'class-variance-authority';
import Popover, { type PopoverProps } from './Popover';
import DropdownMenuItem from './DropdownMenuItem';
type DropdownMenuProps = {
  className?: string;
  style?: CSSProperties;
  enabled?: boolean;
  content: ReactNode | FC<{
    open: () => void;
    close: () => void;
  }>;
} & Pick<PopoverProps, 'as' | 'position' | 'children'>;
export default function DropdownMenu(t0) {
  const $ = _c(9);
  const {
    content,
    className,
    style,
    as,
    position,
    enabled: t1,
    children
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  if (!enabled) {
    return children;
  }
  let t2;
  if ($[0] !== className || $[1] !== content || $[2] !== style) {
    t2 = t3 => {
      const {
        open,
        close
      } = t3;
      return <div style={style} className={cx("my-2 rounded-md border border-gray-200 shadow-lg", className)}><div className="shadow-2xs rounded-md bg-white" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">{typeof content === "function" ? content({
            open,
            close
          }) as Exclude<ReactNode, Promise<ReactNode>> : content}</div></div>;
    };
    $[0] = className;
    $[1] = content;
    $[2] = style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== as || $[5] !== children || $[6] !== position || $[7] !== t2) {
    t3 = <Popover as={as} position={position} content={t2}>{children}</Popover>;
    $[4] = as;
    $[5] = children;
    $[6] = position;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
DropdownMenu.Item = DropdownMenuItem;